<template>
  
<span>

	<Menu/>
	
	<b-row style="margin-top:125pt">
		<b-col>
			<b-overlay
				:show="true"
				opacity="0"
				variant="white"
				no-center>
				
				<b-carousel>
			
					<b-carousel-slide>

						<template v-slot:img>
							<b-img
							class="d-block img-fluid w-100"
							width="1024"
							height="480"
							:src="require('../../assets/stock/gray-desk-1.jpg')"
							alt="image slot"
							:rounded="true"/>



						</template>

						
						
					

					</b-carousel-slide>

				</b-carousel>

				
				<template v-slot:overlay>
					
					<div 
						class="d-flex h-100 align-items-center justify-content-left"
						style=" color:#FFFFFF">
						
							<p class="pl-3 display-4 d-none d-sm-block">
								Choose the subscription <br/>that's right for you.
							</p>

							
							<p class="pl-3 display-4 d-sm-none">
								Choose the subscription <br/>that's right for you.
							</p>

					</div>

				</template>
					
			
				
			
			</b-overlay>
		</b-col>
	</b-row>

	<b-row class="mt-5">
		<b-col>
			
			<h1 class="display-3">
				Pricing
			</h1>

			<b-card-group deck>
                
                	<b-card
					style="color:black">

					<h2 class="display-4">
					<b-link :to="{name: 'signup', params: {action: 'signup', tier: 'free'}}">Early Adopter</b-link>
					</h2>
					<h6 class="text-secondary">Free.</h6>

					<b-card-text>
						<p>The Early Adopter subscription is free and includes the following features (click each for details):</p>

						<b-list-group>
						

							<b-overlay
								:show="features.contexts"
								:opacity="opacity"
								:variant="variant">
								
								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('contexts')">

									Contexts
									<b-icon icon="at"/>
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.contexts}}
								</template>

							</b-overlay>
							
							<b-overlay
								:show="features.filters"
								:opacity="opacity"
								:variant="variant">
								
								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('filters')">

									Custom Filters
									<b-icon icon="filter"/>
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.filters}}
								</template>

							</b-overlay>

							<b-overlay
								:show="features.dashboard"
								:opacity="opacity"
								:variant="variant">
								
								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('dashboard')">

									Dashboard
									<b-icon icon="pie-chart-fill"/>
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.dashboard}}
								</template>

							</b-overlay>
							
							<b-overlay
								:show="features.import"
								:opacity="opacity"
								:variant="variant">
								
								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('import')">

									Data Import
									<b-icon icon="box-arrow-down"/>
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.import}}
								</template>

							</b-overlay>
							
							<b-overlay
								:show="features.dates"
								:opacity="opacity"
								:variant="variant">
								
								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('dates')">

									Dates
									<b-icon icon="calendar"/>
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.dates}}
								</template>

							</b-overlay>
							
							<b-overlay
								:show="features.folders"
								:opacity="opacity"
								:variant="variant">
								
								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('folders')">

									Folder
									<b-icon icon="folder"/>
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.folders}}
								</template>

							</b-overlay>

							<b-overlay
								:show="features.markdown"
								:opacity="opacity"
								:variant="variant">
								
								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('markdown')">

									Markdown
									<b-icon icon="markdown-fill"/>
								</b-list-group-item>

								<template v-slot:overlay>
									Format your comments with
									<b-link href="https://www.markdownguide.org/" target="_new">
									Markdown</b-link>
								</template>

							</b-overlay>

							<b-overlay
								:show="features.mobile"
								:opacity="opacity"
								:variant="variant">
								
								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('mobile')">

									Mobile-friendly
									<b-icon icon="phone"/>
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.mobile}}
								</template>

							</b-overlay>	

							<b-overlay
								:show="features.nestedFolders"
								:opacity="opacity"
								:variant="variant">
								
								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('nestedFolders')">

									Nested Folders
									<b-icon icon="list-nested"/>
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.nestedFolders}}
								</template>

							</b-overlay>

							<b-overlay
								:show="features.priorities"
								:opacity="opacity"
								:variant="variant">
								
								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('priorities')">

									Priority
									<b-icon icon="exclamation"/>
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.priorities}}
								</template>

							</b-overlay>

							<b-overlay
								:show="features.reminders"
								:opacity="opacity"
								:variant="variant">
								
								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('reminders')">

									Reminders
									<b-icon icon="alarm-fill"/>
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.reminders}}
								</template>

							</b-overlay>

							<b-overlay
								:show="features.repeatingTasks"
								:opacity="opacity"
								:variant="variant">
								
								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('repeatingTasks')">

									Repeating Tasks
									<b-icon icon="arrow-repeat"/>
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.repeatingTasks}}
								</template>

							</b-overlay>

							<b-overlay
								:show="features.stars"
								:opacity="opacity"
								:variant="variant">
							
								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('stars')">

									Star
									<b-icon icon="star"/>
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.stars}}
								</template>

							</b-overlay>

							<b-overlay
								:show="features.statuses"
								:opacity="opacity"
								:variant="variant">
							
								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('statuses')">

									Status
									<b-icon icon="circle-half"/>
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.statuses}}
								</template>

							</b-overlay>
							
							<b-overlay
								:show="features.subTasks"
								:opacity="opacity"
								:variant="variant">

								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('subTasks')">
									Sub-tasks
									<b-icon icon="file-plus"/>
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.subTasks}}
								</template>
							</b-overlay>

							<b-overlay
								:show="features.templatesPublic"
								:opacity="opacity"
								:variant="variant">

								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('templatesPublic')">
									
									Public Templates
									
									<b-icon icon="list"/>
								
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.templatesPublic}}
								</template>

							</b-overlay>

							<b-overlay
								:show="features.visibility"
								:opacity="opacity"
								:variant="variant">

								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('visibility')">
									
									Visibility
									
									<b-icon icon="arrows-expand"/>
								
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.visibility}}
								</template>

							</b-overlay>

						</b-list-group>

					</b-card-text>

					
				</b-card>

				<b-card
					style="color:black">
							
					<h2 class="display-4">
					<b-link :to="{name: 'signup', params: {action: 'signup', tier: 'paid'}}">Early Patron</b-link>
					</h2>
					
					<h6 class="text-secondary">As low as $2/month.</h6>
					
					<b-card-text>
						<p>In addition to the features available to Early Adopters, Patrons have access to (click each for details): </p>

						<b-list-group>
						
							<b-overlay
								:show="features.kanban"
								:opacity="opacity"
								:variant="variant">
								
								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('kanban')">

									Kanban
									<b-icon icon="kanban"/>
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.folders}}
								</template>

							</b-overlay>

							<b-overlay
								:show="features.templatesPrivate"
								:opacity="opacity"
								:variant="variant">

								<b-list-group-item 
									class="d-flex justify-content-between align-items-center"
									@click="over('templatesPrivate')">
									
									Private Templates
									
									<b-icon icon="list"/>
								
								</b-list-group-item>

								<template v-slot:overlay>
									{{featureText.templatesPrivate}}
								</template>

							</b-overlay>

							<b-list-group-item 
								class="d-flex justify-content-between align-items-center">

								Support the growth of a small company.
								<b-icon icon="emoji-sunglasses"/>
							</b-list-group-item>

							<b-list-group-item 
								class="d-flex justify-content-between align-items-center">

								Support the improvement of Principal Task.
								<b-icon icon="hammer"/>
							</b-list-group-item>

						</b-list-group>

					</b-card-text>

					
				</b-card>

			</b-card-group>

		</b-col>
	</b-row>
	
	<b-row align-h="around" cols="12">
		<b-col cols="12"
			style="text-align:center;">
			<b-button :to="{name: 'signup', params: {action: 'signup'}}" 
                            variant="success" class="mt-3">Get Started</b-button>
		</b-col>
	</b-row>
	

</span>
</template>
<script>

	import Menu from '@/components/menus/Menu4.vue'
	import features from '@/mixins/features'

	export default {
		name: 'Pricing4',
		metaInfo() {
			return {
				title: 'Principal Task | Pricing',
				meta: [
					{
						name: 'description',
						content: 'Principal Task pricing information.'
					},
					{
						property: 'og:description',
						content: 'Principal Task pricing information.'
					},
					{
						property: 'og:image',
						content: 'http://www.principaltask.com/img/PTLogo-Cropped-1.fafd2068.png'
					},
					{
						property: 'og:title',
						content: 'Principal Task | Pricing'
					},
					{
						property: 'og:type',
						content: 'website'
					},
					{
						name: 'twitter:card',
						content: 'summary_large_image'
					},
					{
						name: 'twitter:description',
						content: 'Principal Task pricing information.'
					},
					{
						property: 'twitter:image',
						content: 'https://www.principaltask.com/img/PTLogo-Cropped-1.fafd2068.png'
					},
					{
						name: 'twitter:site',
						content: '@PrincipalTask'
					},
					{
						name: 'twitter:title',
						content: 'Principal Task | Pricing'
					},
				]
			}
		},
		components: {
            Menu
		},
		mixins: [
			features,
		],
		props: {
		},
		data () {
			return {
				
			}
		},
		methods: {
			
		},    

}
</script>